import { fromJS } from 'immutable';

import { TOASTR_HIDE_ALL, TOASTR_SHOW } from './constants';

// The initial state of the App
const initialState = fromJS({
  messageType: '',
  message: '',
  show: false,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case TOASTR_SHOW:
      return state.set('messageType', action.messageType)
      .set('message', action.message)
      .set('show', true);
    case TOASTR_HIDE_ALL:
      return state.set('show', false)
      .set('messageType', 'none')
      .set('message', '');
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./app/containers/Toastr/reducer.js